const TimeOff = {
  timeOff: {
    title: "Tiempo Libre",
    user: "Usuario",
    team: "Equipo",
    accumulated: "Disponible",
    requested: "Solicitado",
    pending: "Pendiente",
    all: "Todos",
    days: "Días",
    name: "Nombre",
    category: "Categoría",
    status: "Estado",
    approved: "Aprobado",
    rejected: "Rechazado",
    missing_approval: "Aprobación Pendiente",
    history: "Historial de solicitudes",
    freeDays: "Días libres",
    noFreeDays: "No hay politicas de tiempo libre",
    noHistory: "No hay historial de solicitudes",
    detailTitle: "Detalle de uso de días libres",
    headersDays: {
      category: "Categoría",
      politic: "Política",
      solicited: "Solicitado",
      accumulated: "Disponible",
    },
    headersHistory: {
      date: "Fecha",
      politic: "Política",
      solicited: "Solicitado",
      approved: "Aprobador",
      state: "Estado",
    },
    filter: {
      team: "Filtrar por equipo",
      policy: "Filtrar por política",
    },
    tabs: {
      all: "Todos",
      admin: "Administrativo",
      legal: "Legal",
      additional: "Adicional",
    },
    months: {
      0: "Enero",
      1: "Febrero",
      2: "Marzo",
      3: "Abril",
      4: "Mayo",
      5: "Junio",
      6: "Julio",
      7: "Agosto",
      8: "Septiembre",
      9: "Octubre",
      10: "Noviembre",
      11: "Diciembre",
    },
  },
};

export default TimeOff;
